import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AlertsService } from '../../services/utelize/system/alert/alerts-service';
import { AuthenticationService } from '../../services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { ConfigSystemParams } from '../../consts';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { IdAndDescriptionDTO } from '../../interfaces/general/id-description';

@Component({
  selector: 'app-dropdown-alert-type',
  templateUrl: './dropdown-alert-type.component.html',
  styleUrls: ['./dropdown-alert-type.component.scss']
})

export class DropdownAlertTypeComponent implements AfterViewInit, OnInit {

  @Input() alertGroupId                  : number  | undefined;
  @Input() companyId                     : number  | undefined;
  @Input() initialTypeAlertId            : number  | undefined;
  @Input() retainFirstBlankOption        : boolean | undefined;
  @Input() showAllSureSimTypeAlerts      : boolean | undefined;
  @Input() showCompanySureSimTypeAlerts  : boolean | undefined;
  @Input() showHierarchySureSimTypeAlerts: boolean | undefined;
  @Input() userId                        : number  | undefined;
  
  @Output() selectOnChangeEvent     : EventEmitter<number> = new EventEmitter<number>();
  @Output() selectOnChangeIccidEvent: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('typeAlertSelect') typeAlertSelect!: ElementRef;
    
  get selectAllOption() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownsProvideSelectAllOption, false ); }
  
  private curUserID       : number;
  private typeAlertIdData!: IdAndDescriptionDTO[];

  public addOrEditForm!      : UntypedFormGroup;
  public firstTypeAlertOption: string="";
  
  constructor(
    private alertsService        : AlertsService,
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : FormBuilder
  ) {
    this.curUserID=this.authenticationService.currentUserObject().userId;
  }

  ngOnInit(): void {
    try {
      this.getDropdownData();

      let typeAlertId          =this.initialTypeAlertId==undefined ? 0 : this.initialTypeAlertId;
      this.firstTypeAlertOption="";

      this.addOrEditForm=this.formBuilder.group({
        typeAlertID: [typeAlertId, []]
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  ngAfterViewInit(){
    try {
      this.selectOnChange(undefined, undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearSelection() {
    try {
       this.addOrEditForm.get('typeAlertID')?.reset();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public getDropdownDataObjectArray() {
    try {
      return this.typeAlertIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
 
  private getDropdownData() {
    try {
      let dataSource: Observable<IdAndDescriptionDTO[]>;

      dataSource=this.alertsService.getTypeAlertIdAndDescription(this.alertGroupId ?? 0);

      dataSource
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.typeAlertIdData=(data as IdAndDescriptionDTO[]);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshData() {
    this.getDropdownData();
  }

  public selectOnChange(event: Event | undefined, iccid: string | undefined) {
    try {
      let typeAlertID=this.addOrEditForm.controls["typeAlertID"].value;

      if (isNaN(typeAlertID) || typeAlertID=="") {
        typeAlertID=-1;
      }
      
      this.selectOnChangeEvent.emit(typeAlertID);
      this.selectOnChangeIccidEvent.emit(iccid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
